import React, { Component } from 'react';
import { Layout } from 'antd';
import { Breadcrumb, Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import Dimensions from 'react-dimensions';
import { inject, observer  } from 'mobx-react';
import { Footer, FooterMobile } from './footer';

import logo from '~/views/live/assets/logo_pro.png';
import styles from './base.module.css';

const { Header, Content } = Layout;

const Container = ({ children, className }) => {
  return (
    <div className={`${styles.container} ${className}`}>
      {children}
    </div>
  );
};

@inject('app', 'weibo', 'fb')
@observer
class Base extends Component {
  render() {
    const { children, lang, weibo, fb } = this.props;
    const { langs, isMobile, breadcrumbs, currentPlatform } = this.props.app;

    return (
      <Layout className={styles.layout}>
        {/* header */}
        <Header className={styles.header}>
          <Container>
            <Row type="flex" justify="space-between" align="center">
              <Col span={12}>
                <Link to={'/live'}>
                  <div className={styles.logo}>
                    <img className={styles.img} src={logo} alt="" />
                    <div className={styles.text}>{langs['live_title']}</div>
                  </div>
                </Link>
              </Col>
              <Col span={12}>
                <Row type="flex" justify="end" align="center">
                  
                  

                  <Col>
                    {isMobile?null:[
                      fb.accessToken&&currentPlatform==='facebook'?(
                        <div style={{ display: 'inline-block' }} key={'facebook'}>
                          {fb.userName?fb.userName:null}
                          <a style={{ padding: '0 1em' }} onClick={fb.clearToken}>{langs['live_fb_create_user_logout']}</a>
                        </div>
                      ):null,
                      weibo.accessToken&&currentPlatform==='weibo'?(
                        <a key={'weibo'} style={{ padding: '0 1em' }} onClick={weibo.clearToken}>{langs['live_fb_create_user_logout']}</a>
                      ):null
                    ]}

                    {lang ? lang : null}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </Header>

        {/* content */}
        <Content className={styles.content}>
          <Container>

            <div className={styles.breadcrumbs}>
              <Breadcrumb style={{ margin: '12px 0' }}>
                {breadcrumbs.map((v, k) => {
                  return (
                    <Breadcrumb.Item key={k}>
                      <Link to={v.link}>{langs[v.textKey]}</Link>
                    </Breadcrumb.Item>
                  );
                })}
              </Breadcrumb>
            </div>

            <div className={styles.content_box}>
              {children}
            </div>
          </Container>
        </Content>

        {/* footer */}
        {isMobile?<FooterMobile />:<Footer />}
      </Layout>
    );
  }
}

export default Dimensions()(Base);



// WEBPACK FOOTER //
// ./src/layouts/base.js